import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12300fd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "btns" }

import { computed, PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElement, PPTElementLink } from '@/types/slides'
import useLink from '@/hooks/useLink'

import { Divider } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkHandler',
  props: {
  elementInfo: {
    type: Object as PropType<PPTElement>,
    required: true,
  },
  link: {
    type: Object as PropType<PPTElementLink>,
    required: true,
  },
  openLinkDialog: {
    type: Function as PropType<() => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { canvasScale } = storeToRefs(mainStore)
const { slides } = storeToRefs(slidesStore)
const { removeLink } = useLink()
const height = computed(() => props.elementInfo.type === 'line' ? 0 : props.elementInfo.height)

const turnTarget = (slideId: string) => {
  const targetIndex = slides.value.findIndex(item => item.id === slideId)
  if (targetIndex !== -1) {
    mainStore.setActiveElementIdList([])
    slidesStore.updateSlideIndex(targetIndex)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "link-handler",
    style: _normalizeStyle({ top: _unref(height) * _unref(canvasScale) + 10 + 'px' })
  }, [
    (__props.link.type === 'web')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "link",
          href: __props.link.target,
          target: "_blank"
        }, _toDisplayString(__props.link.target), 9, _hoisted_1))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (turnTarget(__props.link.target)))
        }, "幻灯片页面 " + _toDisplayString(__props.link.target), 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.openLinkDialog()))
      }, "更换"),
      _createVNode(_unref(Divider), { type: "vertical" }),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(removeLink)(__props.elementInfo)))
      }, "移除")
    ])
  ], 4))
}
}

})